import React from 'react';
import { ReactComponent as ChipSvgIcon } from './poker-chip-svgrepo-com.svg';
import SvgIcon from "@mui/material/SvgIcon";

const ChipIcon = () => (
	<SvgIcon color="primary">
		<ChipSvgIcon />
	</SvgIcon>
);

export default ChipIcon;